import React from 'react'
import SVG from 'react-inlinesvg'
import Section from '../Section'
import Markdown from 'features/Markdown'
import sLay from 'styles/modules/layout.scss'
import { Row, Col } from 'components/Layout'
import s from './ScreenshotsCarousel.scss'
import cn from 'classnames'

export default class ScreenshotsCarousel extends React.Component {
  state = {
    active: 0,
  }

  render() {
    const props = this.props

    return (
      <Section
        color={props.color}
        paddingTop={props.paddingTop}
        paddingBottom={props.paddingBottom}
      >
        <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
          <Col className={sLay['flex-gt-xs-40']}>
            <Markdown text={props.text} color={props.color} />

            <Row className={cn(sLay['layout-row'], sLay['layout-wrap'], s.options)}>
              {props.items.map((item, idx) => (
                <Col
                  key={idx}
                  className={cn(sLay['flex-33'], { [s.active]: this.state.active === idx })}
                  onClick={() => this.setState({ active: idx })}
                >
                  <SVG src={item.fields.icon.fields.file.url} title={item.fields.title} />
                  <div>{item.fields.icon.fields.title}</div>
                </Col>
              ))}
            </Row>
          </Col>
          <Col className={sLay['flex-gt-xs-60']} style={{ position: 'relative' }}>
            <div className={s.screenshot}>
              <img
                src={props.items[this.state.active].fields.screenshot.fields.file.url}
                alt={props.items[this.state.active].fields.screenshot.fields.title}
              />
            </div>
          </Col>
        </Row>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ScreenshotsCarousel/ScreenshotsCarousel.jsx